import client from "./axios";

const vizUrl = `${window.__env.KRAKEND_URL}/v1/data-exploration`;

export const VizClient = {
  getDatabases: (body: any, type: string, params?: URLSearchParams) => client.post(`${vizUrl}/${type}/databases`, body, { params }),
  getTables: (body: any, type: string, params?: URLSearchParams) => client.post(`${vizUrl}/${type}/tables`, body, { params }),
  getTopics: (body: any, type: string, params?: URLSearchParams) => client.post(`${vizUrl}/${type}/topics`, body, { params }),
  getColumns: (body: any, type: string, params?: URLSearchParams) => client.post(`${vizUrl}/${type}/columns`, body, { params }),
  getDatasetPreview: (body: any, type: string) => client.post(`${vizUrl}/${type}/preview`, body),
  getQueryResult: (body: any, type: string) => client.post(`${vizUrl}/${type}/query`, body),
  browseDirectories: (body: any, type: string) => client.post(`${vizUrl}/${type}/browse`, body),
}